import { useMutation } from '@tanstack/react-query';
import { ApiRoutes } from 'src/common/api/ApiRoutes';
import { useAxiosSocket } from 'src/common/api/AxiosContext';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { useUserInfoState } from '../states/useUserInfoState';

export const useSocketUnselectSeatMutation = () => {
  const axios = useAxiosSocket();
  const { userInfo } = useUserInfoState();

  const handleFetch = ({ itemId, channel }: { itemId: string[]; channel: string }) => {
    const payload = {
      payload: {
        itemId,
        userId: userInfo?.id,
      },
      item_id: itemId,
      broadcast: {
        channel,
        event: 'unselected',
      },
    };
    return axios.post(ApiRoutes.unselectSeat, payload);
    // return axios.get<AxiosResponse<SocketSessionProps>>(`healthz`, {});
  };

  return useMutation(handleFetch, {
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
  });
};
